import { CollapsibleSectionHeader, useCollapsible } from "@/features/talent/components/talent-common/CollapsibleSectionHeader";
import { black } from "@/theme/colors";
import { rounded } from "@/theme/variables";
import { FCC } from "@/types/common";
import { Box, Collapse, Typography, styled } from "@mui/material";

type TInputRuleBannerProps = {
  /** The rule text to display. Banner hidden when null/undefined/empty. */
  rule?: string | null;
};

/** Yellow collapsible banner that displays input rules at the top of forms. */
export const InputRuleBanner: FCC<TInputRuleBannerProps> = ({ rule }) => {
  const { expanded, toggle } = useCollapsible();

  if (!rule) return null;

  return (
    <BannerWrapper>
      <CollapsibleSectionHeader title="入力ルール" expanded={expanded} onToggle={toggle} />
      <Collapse in={expanded}>
        <Typography variant="body14Semi" color={black[30]} mt={2} sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
          {rule}
        </Typography>
      </Collapse>
    </BannerWrapper>
  );
};

const BannerWrapper = styled(Box)`
  background: #fff9c4;
  border: 1px solid ${black[95]};
  border-radius: ${rounded.sm};
  padding: 24px;
  margin-bottom: 24px;
`;
